import React, { Component } from "react";

class ResultsToCSV extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    };
  }

  handleDownload = () => {
    const { surveyId } = this.props;
    if (!surveyId) return;

    this.setState({ loading: true });

    // Descargar CSV directamente del nuevo endpoint
    fetch(`/survey/results/csv/${surveyId}`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Error generando CSV');
        }
        return response.blob();
      })
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `resultados_${surveyId}.csv`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        this.setState({ loading: false });
      })
      .catch(error => {
        console.error('Error:', error);
        this.setState({ loading: false });
        alert('Error generando el CSV');
      });
  };

  render() {
    const { loading } = this.state;
    return (
      <div>
        <button
          type="button"
          className="btn btn-primary btn-sm"
          onClick={this.handleDownload}
          disabled={loading}
        >
          {loading ? 'Generando...' : 'Descargar CSV con Labels'}
        </button>
        <hr />
      </div>
    );
  }
}

export default ResultsToCSV;



// WEBPACK FOOTER //
// ./src/components/Admin/surveys/Results/ResultsToCSV/index.js